import { Component, NgZone, Input, OnInit, OnDestroy} from '@angular/core';
import { NavController, NavParams, } from 'ionic-angular';
import { JobApplyObject } from '../../../../../../../UI/src/app/shared/job/job-apply-object.dto';
import { AuthenticationService } from '../../../../../../../UI/src/app/shared/authentication/authentication.service';
import { AuthenticationComponent } from '../../../authentication/authentication.component';
import { JobService } from '../../../../../../../UI/src/app/shared/job/job.service';
import { JobDetailsDTO } from '../../../../../../../UI/src/app/shared/job/job-details.dto';
import { SettingsService } from '../../../../../../../UI/src/app/shared/settings/settings.service';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';
import { SigninComponent } from '../../../authentication/components/signin/signin.component';
import { JobAssessmentComponent } from '../job-assessment/job-assessment.component';

@Component({
    selector: 'sts-job-linkedin',
    templateUrl: 'job-linkedin.component.html'
 })

 export class JobLinkedInComponent implements OnInit, OnDestroy {
    isTrackRequest = false;
    alertData: any;
    public linkedInEnable = false;
    public linkedinAPIKey;
    public linkedInIntegrationContext;
    job: any;
    jobDetails: JobDetailsDTO = null;
    public jobId: any;
    navigatedFrom = '';
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private authService: AuthenticationService,
        private settingsService: SettingsService,
        public jobService: JobService,
        private ngZone: NgZone,
        private resumeService: ResumeService) 
        {
          this.job = navParams.get("jobData");
          this.navigatedFrom = navParams.get("navigatedFrom");
          
          if (this.job && this.job.jobId) {
            this.job.id = this.job.jobId;
          }
          else if(navParams.get("jobId")) {
            this.job = {};
            this.job.id = navParams.get("jobId");
          } else if(navParams.get("trackRequest")){
            this.isTrackRequest = true;
            this.job = { id: navParams.get("trackRequest")};
          }
          if(this.job !== undefined && this.job.id !== undefined) {
                this.jobId=this.job.id;
          }
        }

      ngOnInit(){
        if(this.navParams != null && this.jobId >= 1)
        {
        this.settingsService.GetLoginSettings().subscribe(
            settings => {
                this.authService.setLinkedInDetails(settings);
                if (this.authService.isLinkednInEnabled !== undefined && this.authService.isLinkednInEnabled && this.jobId !== undefined && this.authService.linkedInAPIKeyValue && this.authService.linkedInIntegrationContext) {
                  this.linkedInEnable = this.authService.isLinkednInEnabled && !this.isTrackRequest;
                  this.linkedInIntegrationContext = this.authService.linkedInIntegrationContext;
                  this.linkedinAPIKey = this.authService.linkedInAPIKeyValue;
                  const linkedinWidget = document.createElement('script');
                  linkedinWidget.src = 'https://www.linkedin.com/mjobs/awli/awliWidget';
                  document.body.appendChild(linkedinWidget);
                  
                  window['angCompRef'] = { component: this, zone: this.ngZone, loadAngularFunction: (data: any) => this.onApply(data) };
                  const scriptCB = document.createElement('script');
                  scriptCB.innerHTML = 'function onApply(data){window.angCompRef.zone.run(()=>{window.angCompRef.loadAngularFunction(data)})}';
                  scriptCB.setAttribute('id' , "awliScriptId");
                  document.getElementById( 'applyLinkedIn' ).appendChild(scriptCB);

                  const script = document.createElement('script');
                  script.type = 'IN/AwliWidget';
                  script.setAttribute('data-company-job-code' , this.jobId);
                  script.setAttribute('data-api-key' , this.linkedinAPIKey);
                  script.setAttribute('data-integration-context' ,  this.linkedInIntegrationContext);
                  script.setAttribute('data-mode' , this.isTrackRequest ? 'CONVERSION' : 'BUTTON_DATA');
                  if(!this.isTrackRequest) {
                    script.setAttribute('data-callback-method' , 'onApply');
                    script.setAttribute('data-allow-sign-in' , 'true');
                    script.setAttribute('data-size','small');
                  }
                  document.getElementById( 'applyLinkedIn' ).appendChild( script );
                  this.jobService.trackRequest = null;
                  }
            });
          }
      }

      ngOnDestroy() {
        // clean up linkedin scripts
        const scriptList = [
          'www.linkedin.com/mjobs/awli/awliWidget',
          'platform.linkedin.com/in.js',
          'www.linkedin.com/talentwidgets/extensions/apply-with-linkedin-widget-v3'];
          
        delete window['IN'];
        Array.from(document.body.querySelectorAll('script')).forEach(e => {
          if(scriptList.find(i =>  e.src.indexOf(i) != -1)){
           e.remove();
          }});
        Array.from(document.body.getElementsByClassName('IN-staging')).forEach(e => e.remove());
      }

      onApply(profileData){
        this.resumeService.linkedInResume = profileData;
        this.authService.isAppliedwithLinkedIn = true;
        this.jobService.IsJobApplied  = undefined;
        if(this.authService.isUserLoggedin())
        {
          var jobObject =  this.jobService.getApplyJobObject();
          if(jobObject.IsDrafted) {
            this.jobService.getAssessmentIdForRequisition(jobObject.JobId).subscribe(
              (response) => {
                this.navCtrl.push(JobAssessmentComponent, {"assessmentId": response, "jobId": jobObject.JobId, "navigatedFrom": this.navigatedFrom, "applicationId": jobObject.ApplicationId, isDrafted: jobObject.IsDrafted, "isAssessment":false});
              });
             } else {
              this.navCtrl.push(AuthenticationComponent, { "action": "linkedin"});
          }
        }
        else
        {
          this.authService.checkUserIsExist(profileData.emailAddress).subscribe(
            (response) => {
                if(response !== null && response)
                  this.navCtrl.push(SigninComponent,{action:"request", isEmail: profileData.emailAddress});
                else
                this.navCtrl.push(AuthenticationComponent, { "action": "linkedin"});
            });
        }
        
      }
 }
 



// WEBPACK FOOTER //
// ./src/app/modules/job-search/components/job-linkedin/job-linkedin.component.ts